import React, { ReactElement, useEffect } from 'react';
import { MOBILE_MASK_REGEX_WITHOUT_PREFIX, MOBILENO_REPEAT_SEQUENCE_REGEX } from '../../../constants/commonConstants';
import { useGetFormConfig } from '../../../hooks/useFormConfig';
import FormItem from '../FormItem/FormItem';
import InputMask from '../InputMask/InputMask';

const FormInputMobile = (props: any): (ReactElement | null) => {
  const formConfig = useGetFormConfig(props);
  const {
    label, placeholder, disabled, rules, key, allowClear, onChange, onBlur, prefix, showPrefix, onFocus,
    fieldInFocus, inputRef, className,
  } = formConfig;
  const innerInputRef = React.useRef<any>(null);
  rules.push({
    pattern: showPrefix ? new RegExp(MOBILE_MASK_REGEX_WITHOUT_PREFIX)
      : new RegExp(MOBILENO_REPEAT_SEQUENCE_REGEX),
    message: `Please enter valid ${label}`,
  });

  // Add effect to handle focus when fieldInFocus prop changes
  useEffect((): void => {
    if (fieldInFocus && innerInputRef?.current) {
      innerInputRef.current.focus();
    }
  }, [fieldInFocus]);

  return <FormItem formConfig={formConfig}>
    <InputMask {...props}
      data-testid={key}
      allowClear={allowClear}
      mask={showPrefix ? '999 9999 999' : '+\\91 999 9999 999'}
      placeholder={placeholder}
      disabled={disabled}
      onChange={onChange}
      className={className}
      prefix={prefix}
      onBlur={onBlur}
      ref={(node: any): void => {
        innerInputRef.current = node;
        if (inputRef) {
          typeof inputRef === 'function' ? inputRef(node) : (inputRef.current = node);
        }
      }}
      onFocus={(event: React.FocusEvent<HTMLInputElement>): void => {
        onFocus?.(event);
      }}
      maskChar=" " />
  </FormItem>;
};

export default FormInputMobile;
